import type { IconProps } from '../types/IconProps.ts';
export const Play: IconProps = {
    name: 'Play',
    children: [
        `<path d="M5 20.15V3.65a1 1 0 0 1 1.46-.88L20.5 10.1a1 1 0 0 1 .08 1.72L6.55 21A1 1 0 0 1 5 20.15" />`,
    ]
};